/**
 * Where the app POSTs bug reports so they sync into the repo automatically.
 *
 * Set this to the feedback collector's URL reached over Tailscale, e.g.
 * https://<your-machine>.ts.net/collector  (the launcher prints the exact URL).
 * The app appends /feedback to it. Leave it empty to fall back to the same-origin
 * /__feedback endpoint (the vite dev/preview server), which is what a browser on
 * the Tailscale-served preview already uses.
 *
 * No secret here — it's just a private tailnet address. The collector accepts any
 * report over the tailnet and only appends it to a local file.
 */
export const FEEDBACK_COLLECTOR_URL = 'https://ardent-author.taild93819.ts.net/collector';
